import React, {useEffect, useState} from 'react';
import './index.css';

function TotalGames(props) {
    const [percentList, updatePercentList] = useState([])
    const hour_and_min_calculate = (min_time) => {
        return (
            <>
                {/*<span>{ min_time >= 60 ? parseInt(min_time/60) : 0}</span>*/}
                {/*<span className="p-[min(0.5vw,1vh)]"> ساعت و </span>*/}
                {/*<span>{ min_time >= 60 ? min_time%60 : min_time}</span>*/}
                <span>{parseInt(min_time).toLocaleString()}</span>
                <span className="p-[min(0.5vw,1vh)]"> دقیقه </span>
            </>
        )
    }

    useEffect(() => {
        const lll = [0, 0, 0, 0, 0, 0];
        let total = 0
        props.grades.map((item, index) => {
            if (index > 0) {
                total += props.stateData["total_played_games"][item[0]]["number"] / props.stateData["total_played_games"]["total"]["number"] * 100
                lll[index - 1] = total
                console.log(total)
            }
        });
        updatePercentList(lll)
    }, [props.stateData["total_played_games"]]);
    const chart = {
        backgroundImage: `conic-gradient(
                             ${props.grades[1][2]} ${percentList[0]}%,
                             ${props.grades[2][2]} ${percentList[0]}%, ${props.grades[2][2]} ${percentList[1]}%,
                             ${props.grades[3][2]} ${percentList[1]}%, ${props.grades[3][2]} ${percentList[2]}%,
                             ${props.grades[4][2]} ${percentList[2]}%, ${props.grades[4][2]} ${percentList[3]}%,
                             ${props.grades[5][2]} ${percentList[3]}%, ${props.grades[5][2]} ${percentList[4]}%,
                             ${props.grades[6][2]} ${percentList[4]}%)`
    }
    return (
        <>
            <div
                className="flex flex-row rounded-[min(1vw,2vh)] justify-center items-center h-[min(5vw,10vh)] text-white my-[min(1vw,2vh)] bg-[#001037]">

                <div onClick={() => {props.changeTotalToEnteredAndBack(false, "total_games")}}
                     className={`flex flex-row text-[min(1.2vw,2.4vh)] transition-all duration-400 cursor-pointer justify-center mr-[1%] border-[min(0.2vw,0.4vh)] border-[#4044ED] items-center rounded-[min(0.5vw,1vh)] w-[20%] h-[60%] bg-[#${props.situation.denominator === "total" ? "001037" : "4044ED"}]`}>
                    جزئیات فعالیت ها
                    <img className="h-[70%] ml-[5%]" src={"https://uploads.zibazi.tv/site/assets/organ/dashboard/total1.png"} alt="icon"/>
                </div>
                <div onClick={() => {props.changeTotalToEnteredAndBack(true, "total_games")}}
                     className={`flex flex-row text-[min(1.2vw,2.4vh)] transition-all duration-400 cursor-pointer justify-center ml-[1%] border-[min(0.2vw,0.4vh)] border-[#4044ED] items-center rounded-[min(0.5vw,1vh)] w-[20%] h-[60%] bg-[#${props.situation.denominator === "total" ? "4044ED" : "001037"}]`}>
                    کل فعالیت ها
                    <img className="h-[70%] ml-[5%]"  src={"https://uploads.zibazi.tv/site/assets/organ/dashboard/entered1.png"} alt="icon"/>
                </div>
            </div>
            {
                props["situation"]["denominator"] === "total" ?


                    <div
                        className="flex flex-col rounded-[min(1vw,2vh)] justify-center items-center h-full w-full text-black">

                        <div
                            className="flex flex-col justify-center items-center rounded-[min(0.5vw,1vh)] h-[50%] mb-[min(0.5vw,1vh)] px-[5%] w-full bg-gradient-to-br from-[#FFE747] to-[#F5D400]">
                            <div
                                className="flex flex-row text-[min(1.2vw,2.4vh)] w-full items-end justify-center h-[25%] z-[3]">
                                "مدت زمان فعالیت ها"
                            </div>
                            <span className="absolute h-[min(15vw,30vh)] w-[min(15vw,30vh)] border-[min(1.5vw,3vh)] border-[#FBDF2B] shadow-[0px_0px_0px_min(1.5vw,3vh)_#F5D505] rounded-full bg-[#FDE43E] z-[2]">
                            </span>
                            <div
                                className="flex flex-row-reverse w-full justify-center items-center text-left h-[70%] text-[min(5vw,10vh)] text-start z-[3]" style={{fontWeight:700}}>
                                {hour_and_min_calculate(props.stateData["total_played_games"]["total"]["time_min"])}
                            </div>
                        </div>
                        <div
                            className="flex flex-col justify-center items-center rounded-[min(0.5vw,1vh)] h-[50%] px-[5%] mt-[min(0.5vw,1vh)] w-full bg-gradient-to-tr from-[#FFD770] to-[#FFC01F]">
                            <div
                                className="flex flex-row w-full text-[min(1.2vw,2.4vh)] justify-center items-end h-[25%] z-[3]">
                                "میزان فعالیت (کل بازی های انجام شده)"
                            </div>
                            <span className="absolute h-[min(15vw,30vh)] w-[min(15vw,30vh)] border-[min(1.5vw,3vh)] border-[#FFC941] shadow-[0px_0px_0px_min(1.5vw,3vh)_#FFBE19] rounded-full bg-[#FFD25F] z-[2]">
                            </span>
                            <div
                                className="flex flex-row-reverse text-[min(5vw,10vh)] z-[3] w-full justify-center items-center text-left h-[74%]" style={{fontWeight:700}}>
                                <span>{parseInt(props.stateData["total_played_games"]["total"]["number"]).toLocaleString()}</span>
                                <span className="p-[min(0.5vw,1vh)]"> بازی </span>
                            </div>
                        </div>
                    </div>
                    :
                    <div
                        className="flex flex-row w-full h-full bg-[#001037] rounded-[min(1vw,2vh)] overflow-hidden justify-center items-center">
                        <div className="flex flex-row h-full w-full">
                            <div className="flex items-center justify-center w-[47.5%] p-[min(4vw,8vh)] h-full">
                                <div
                                    className="flex items-center justify-center w-full h-full rounded-full transition-all duration-700 transition-transform duration-500 transform"
                                    style={chart}>
                                    <div
                                        className="flex flex-col text-white justify-center items-center w-[50%] h-[50%] rounded-full bg-[#001037]">
                                        <span
                                            className="text-[min(3vw,6vh)]">{parseInt(props.stateData["total_played_games"]["total"]["time_min"]).toLocaleString()}</span>
                                        <span className="p-[min(0.5vw,1vh)] text-[min(1.5vw,3vh)]"> دقیقه </span>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="flex flex-col items-center justify-center w-[50%] p-[min(1vw,2vh)] h-full">
                                {props.grades.map((item, index) => (
                                    index > 0 &&
                                    <div
                                        className={`flex  text-[min(1.2vw,2.4vh)] flex-row-reverse h-[12%] border-[min(0.3vw,0.6vh)] border-[${props.grades[index][2]}] rounded-[min(0.5vw,1vh)] m-[min(0.5vw,1vh)] justify-center items-center text-black w-full`} style={{backgroundColor: props.grades[index][3]}}>
                                        <span
                                            className="flex flex-row-reverse m-[5%] w-[min(1vw,2vh)] h-[min(1vw,2vh)] rounded-sm"
                                            style={{backgroundColor: props.grades[index][2]}}></span>
                                        <span className="flex flex-row-reverse w-[20%]">{item[1]}</span>
                                        <span
                                            className="flex flex-row-reverse w-[30%]">{parseInt(props.stateData["total_played_games"][item[0]]["number"] / props.stateData["total_played_games"]["total"]["number"] * 1000) / 10}%</span>
                                        <span
                                            className="flex flex-row-reverse w-[40%] items-center">{hour_and_min_calculate(props.stateData["total_played_games"][item[0]]["time_min"])}</span>
                                    </div>
                                ))}
                            </div>

                        </div>
                    </div>

            }
        </>
    );
}

export default TotalGames;